import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useState } from 'react';
import { t } from '../../../../../types/translation/Translator';
import CloseIcon from '../../../../icons/Close/CloseIcon';
import FileViewLoader from '../FileViewLoader';
import ImagePickerModal from './ImagePickerModal';
import { FileEntityType, FilePreview } from '../../../../../types/file';
import ImageView from './ImageView';

interface ImagePickerProps {
  fileSasIdsOrPreviews: (string | FilePreview)[];
  onSelected: (selected: string) => void;
  onRemove?: () => void;
  fileId?: string;
  height?: string;
  width?: string;
  fileEntityType: FileEntityType;
}

export default function ImagePicker({
  fileSasIdsOrPreviews,
  fileId,
  height = '180px',
  width = '300px',
  onSelected,
  onRemove,
  fileEntityType,
}: ImagePickerProps) {
  const [open, setOpen] = useState(false);

  const file = fileSasIdsOrPreviews.find(f => typeof f !== 'string' && f.id === fileId) as FilePreview | undefined;

  return (
    <>
      <ImagePickerModal
        fileSasIdsOrPreviews={fileSasIdsOrPreviews}
        open={open}
        setOpen={setOpen}
        onSelected={onSelected}
        fileEntityType={fileEntityType}
      />

      <div className='relative select-none rounded border-2 border-dashed border-gray-300 p-6'>
        {fileId ? (
          <div style={{ width, height }} className='flex items-center justify-center'>
            <>
              <CloseIcon className='absolute right-1 top-1 cursor-pointer text-red-400' onClick={onRemove} />
              {file ? (
                <ImageView url={file.data} />
              ) : (
                <FileViewLoader fileEntityType={fileEntityType} fileId={fileId} />
              )}
            </>
          </div>
        ) : (
          <div
            onClick={() => setOpen(true)}
            style={{ width, height }}
            className='flex cursor-pointer flex-col items-center justify-center text-center text-[14px] text-gray-900'
          >
            <p>{t(TranslationKey.clickToSelectAndDisplayProductImage).singular.upper}</p>
            <p className='text-normal text-gray-500'>
              {t(TranslationKey.uploadProductImagesInTheFilesAndAssetsSection).singular.upper}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
